const { WorkShops } = require('./WorkShops');
const { CreateWorkShop } = require('./CreateWorkShop');

export { WorkShops, CreateWorkShop };
